export default {
    noticeFlag: true, 
	fldata: [],
	gallyIndex: '',
	tabIndex: 'sy',
};